import * as React from "react"
import {Box, Typography} from "@mui/material";


export default function ScoreColumnNoDataBlock() {
	return <Box sx={{ textAlign: 'center', position: 'relative' }}>
		<Typography variant="subtitle2">
			<Box sx={{color: 'text.disabled', fontSize: '0.8rem', fontStyle: 'oblique' }}>
				N/A
			</Box>
		</Typography>
	</Box>
}